module.exports = __webpack_public_path__ + "img/bg.72fe4631.jpg";